import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";

export const optimizationQuestionSchema = z.object({
  question: z.string().describe("The question to ask the user"),
  type: z.enum(["radio"]).describe("The type of question to ask the user"),
  options: z
    .array(z.string())
    .optional()
    .default([])
    .describe("The options for the radio type question"),
  placeholder: z.string().optional().describe("The placeholder for the input type question"),
  metric: z.string().describe("The metric to focus on"),
});

export const optimizationQuestionsResponseSchema = z.object({
  questions: z.array(optimizationQuestionSchema),
});

export class OptimizationQuestionDto extends createZodDto(optimizationQuestionSchema) {}
export class OptimizationQuestionsResponseDto extends createZodDto(
  optimizationQuestionsResponseSchema,
) {}
